const convertToFloat = (number) => {
  const parsed = parseFloat(number);

  if (isNaN(parsed)) {
    return 0; 
  }

  return parseFloat(parsed.toFixed(2));
};

export default convertToFloat;
